export default function CustomTooltip({ active, payload }) {
  // We don't want to render anything if the user is not hovering
  if (active && payload && payload.length) {
    return (
      <div
        className="custom-tooltip"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          padding: "10px",
          border: "1px solid #d1d1d1",
          borderRadius: "5px",
          boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <p
          className="label"
          style={{ margin: 0, fontWeight: "bold" }}
        >{`${payload[0].name}'s Guest:`}</p>
        <p
          className="desc"
          style={{ margin: "5px 0 0" }}
        >{`${payload[0].value} pax`}</p>
      </div>
    );
  }

  return null;
}
